import React, { useEffect, useState } from "react";
import useApi from "../../CustomHooks/useApi";

const RecentTransactions = ({ mid }) => {
  const { callApi: fetchLedger } = useApi(
    "/admin/transactions/retailer/recent-transactions",
    "GET"
  );

  const [ledger, setLedger] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadLedger = async () => {
    if (!mid) return;

    setLoading(true);
    try {
      const res = await fetchLedger(null, `?mid=${mid}`);

      // 🔥 normalize data
      const onlyData = res?.slice(0, 5)?.map((item) => item?.data);

      setLedger(onlyData || []);
    } catch (err) {
      console.error("Ledger fetch failed:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadLedger();
  }, [mid]);

  return (
    <div className="bg-white rounded-xl shadow border p-6">
      <h3 className="font-semibold text-lg text-[#0A2A4F] mb-4">
        💳 Recent Transactions
      </h3>

      {loading ? (
        <p className="text-gray-500">Loading...</p>
      ) : ledger.length > 0 ? (
        <div className="overflow-auto border rounded-lg">
          <table className="w-full text-sm border-collapse">
            
            {/* ✅ HEADER */}
            <thead className="bg-gray-100 text-gray-600">
              <tr>
                <th className="px-4 py-2 border">Txn ID</th>
                <th className="px-4 py-2 border">Date</th>
                <th className="px-4 py-2 border">Status</th>
                <th className="px-4 py-2 border">Txn Amount</th>
                <th className="px-4 py-2 border">Consumer No.</th>
                <th className="px-4 py-2 border">Beneficiary Name</th>
                <th className="px-4 py-2 border">Remitter Mobile</th>
                <th className="px-4 py-2 border">Beneficiary A/C</th>
              </tr>
            </thead>

            {/* ✅ BODY */}
            <tbody>
              {ledger.map((txn, i) => {
                const txnId = txn?.txnId || "-";

                const status = txn?.txnStatus || txn?.status || "-";

                const amount = txn?.txnAmount || txn?.amount || 0;

                const date = txn?.date
                  ? new Date(txn.date).toLocaleString("en-IN")
                  : "-";

                const consumerNumber = txn?.consumerNumber || "-";

                const beneficiaryName =
                  txn?.beneficiaryName ||
                  txn?.beneficiary_name ||
                  "-";

                const remitterMobile =
                  txn?.remitterMobileNumber ||
                  txn?.customerMobile ||
                  "-";

                const beneficiaryAcc =
                  txn?.beneficiaryAccountNo ||
                  txn?.beneficiary_account_number ||
                  "-";

                return (
                  <tr key={i} className="hover:bg-gray-50">
                    
                    <td className="px-4 py-2 border">{txnId}</td>
                    
                    <td className="px-4 py-2 border">{date}</td>

                    <td
                      className={`px-4 py-2 border font-semibold ${
                        status === "SUCCESS"
                          ? "text-green-600"
                          : status === "FAILED"
                          ? "text-red-600"
                          : "text-yellow-600"
                      }`}
                    >
                      {status}
                    </td>

                    <td className="px-4 py-2 border">
                      ₹ {Number(amount).toLocaleString("en-IN")}
                    </td>

                    <td className="px-4 py-2 border">
                      {consumerNumber}
                    </td>

                    <td className="px-4 py-2 border">
                      {beneficiaryName}
                    </td>

                    <td className="px-4 py-2 border">
                      {remitterMobile}
                    </td>

                    <td className="px-4 py-2 border">
                      {beneficiaryAcc}
                    </td>

                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="text-gray-400">No transactions found</p>
      )}
    </div>
  );
};

export default RecentTransactions;